/*
 * @Author: etong
 * @Date: 2021-07-02 15:46:13
 * @LastEditTime: 2021-07-05 10:14:45
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\components\CommonSearch\index.js
 * Think first, Program later
 */
import Vue from 'vue'
import CommonSearch from './search'

Vue.component('JJSearch', CommonSearch)
